import { X } from "lucide-react";
import type React from "react";
import type { ChatThread } from "@/features/chat/services/chatService";

interface ThreadTabProps {
	thread: ChatThread;
	isSelected: boolean;
	onSelect: (threadId: string) => void;
	onDelete: (threadId: string, event: React.MouseEvent) => void;
}

export const ThreadTab: React.FC<ThreadTabProps> = ({ thread, isSelected, onSelect, onDelete }) => {
	const label = thread.title?.trim() || `Thread ${new Date(thread.createdAt).toLocaleDateString()}`;
	return (
		<div className="chat-thread-tab-container group">
			<button
				type="button"
				onClick={() => onSelect(thread.id)}
				className={`chat-thread-tab ${isSelected ? "chat-thread-tab--selected" : "chat-thread-tab--unselected"}`}
				title={label}
			>
				{label}
			</button>
			<button
				type="button"
				onClick={(event) => onDelete(thread.id, event)}
				className="chat-thread-delete"
				aria-label="Delete thread"
			>
				<X className="h-3 w-3 text-neutral-500" />
			</button>
		</div>
	);
};
